<template>
    <div class="flex justify-center items-center gap-[30px]">
        <div
v-for="item in dashboardCard" :key="item.label"
            class="group flex flex-col items-center justify-center gap-[20px] shadow-[0px_0px_10px_0px_#cccccc61] w-[200px] h-[200px] rounded-[20px] transition-all duration-300 cursor-pointer bg-[#fff]"
            :class="[
                `hover:bg-[${item.bgColor}]`
            ]"
>
            <div
class="w-[80px] h-[80px] flex items-center justify-center rounded-full group-hover:bg-white" :class="[
                `bg-[${item.bgColor}]`
            ]"
>
                <img
:src="require(`@/assets/images/${item.icon}`)" :alt="item.label"
                    class="w-[40px] h-[40px] object-contain group-hover:hidden block"
>
                <img
:src="require(`@/assets/images/${item.hoverIcon}`)" :alt="item.label"
                    class="w-[40px] h-[40px] object-contain hidden group-hover:block"
>
            </div>
            <h6 class="m-0 text-[20px] font-roboto font-medium text-[#333333] group-hover:text-white">
{{ item.label }}
</h6>
        </div>
    </div>
</template>


<script>

export default {
    data() {
        return {
            dashboardCard: [
                {
                    icon: 'plan-icon.png',
                    hoverIcon: 'plan-hovericon.png',
                    bgColor: '#A084E8',
                    label: 'Plans',
                },
                {
                    icon: 'affiliates-icon.png',
                    hoverIcon: 'affiliates-hovericon.png',
                    bgColor: '#BA90C6',
                    label: 'Affiliates',
                },
                {
                    icon: 'sales_history-icon.png',
                    hoverIcon: 'sales_history-hovericon.png',
                    bgColor: '#29C6CD',
                    label: 'Sales History',
                },
                {
                    icon: 'commission-icon.png',
                    hoverIcon: 'commission-hovericon.png',
                    bgColor: '#7695FF',
                    label: 'Commission',
                },
            ]
        }
    }
}
</script>